// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__-CP-9","footerLinks":"Footer_footerLinks__9VyMu"};